import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { NavLink, Link } from 'react-router-dom';
import Icon from 'components/UI/Icons';
import declOfNum from 'helpers/declOfNum';
import { connect } from 'react-redux';
import Img from 'components/UI/LazyImg';
import TextWithHint from 'components/UI/TextWithHint';

import { getCountProducts, getProducts } from 'helpers/useProductsInLocalStore';

import GlobalEvents from 'setts/globalEvents';

const SelectedProducts = ({ styles, products }) => {
  const productsInStore = getProducts().map((i) =>
    products.find((el) => el.id === i.id),
  );

  return (
    <div className={styles.basketPopup}>
      <ul className={styles.basketPopup_list}>
        {productsInStore.map((product) => (
          <li key={product.id} className={styles.basketPopup_item}>
            <p className={styles.basketPopup_img}>
              <Img src={product.image} alt={product.title} />
            </p>
            <div className={styles.basketPopup_details}>
              <p className={styles.basketPopup_brand}>{product.brand.text}</p>
              <p
                className={classnames(styles.basketPopup_product, 'ba-bold')}
                title={product.title}
              >
                <Link to={`/product/${product.path}`}>
                  <TextWithHint text={product.title} line={3} />
                </Link>
              </p>
            </div>
            <p className={styles.basketPopup_price}>
              {product.retail_price} грн.
            </p>
          </li>
        ))}
      </ul>
      <p>
        <NavLink
          to={'/basket'}
          className={classnames(
            'ba-btn ba-btn--primary',
            styles.basketPopup_linkTo,
          )}
        >
          Перейти в корзину и оформить заказ
        </NavLink>
      </p>
    </div>
  );
};

const EShopLink = ({ styles, products }) => {
  const [isInBasket, setInBusket] = useState(getCountProducts());
  const [showPopup, setPopup] = useState(false);

  useEffect(() => {
    const updateStatus = () => {
      setInBusket(getCountProducts());
    };

    document.body.addEventListener(
      GlobalEvents.updateProductsInStore,
      updateStatus,
    );

    return () => {
      document.body.removeEventListener(
        GlobalEvents.updateProductsInStore,
        updateStatus,
      );
    };
  });

  const countInBasket = () =>
    `${isInBasket} ${declOfNum(isInBasket, ['товар', 'товара', 'товаров'])}`;

  return (
    <li
      className={classnames(styles.nav_item, styles.sublist_wrap)}
      onMouseEnter={() => setPopup(true)}
      onMouseLeave={() => setPopup(false)}
    >
      {isInBasket > 0 ? (
        <>
          <div
            className={classnames(
              styles.link,
              styles.eShop,
              styles.eShop_full,
              'ba-bold',
            )}
          >
            <NavLink
              to={'/beauty-shop'}
              exact
              onClick={() => window.scrollTo(0, 0)}
              className={classnames(styles.link, styles.eShop, 'ba-bold')}
            >
              <Icon name='cart' />
              {countInBasket()}
            </NavLink>
          </div>
          {products.length > 0 && showPopup && (
            <SelectedProducts products={products} styles={styles} />
          )}
        </>
      ) : (
        <NavLink
          to={'/beauty-shop'}
          exact
          onClick={() => window.scrollTo(0, 0)}
          className={classnames(styles.link, styles.eShop, 'ba-bold')}
        >
          <Icon name='cart' />
          Бьютишоп
        </NavLink>
      )}
    </li>
  );
};

const mapStateToProps = ({ web }) => ({
  products: web.products,
  brands: web.brands,
  categories: web.categories,
});

const mapToProps = connect(mapStateToProps, null);

export default mapToProps(EShopLink);
